import { Component, OnInit, ElementRef, ViewChild, NgZone } from '@angular/core';
import { TooltipComponent } from '@realpage-da/ng-map';
import { PropertyDetailPopupComponent, PropertyDetailPopupAnchorDirective } from '../popup';
import { ColorConstants } from '~/shared/utils/color-constants';
import { Observable } from 'rxjs/Observable';
import { PropertyDetailJSON } from '~/core/model';
import { environment } from '~environment';
import { AppConstants } from '~/shared/utils/app-constants';

@Component({
  selector: 'property-tooltip',
  templateUrl: './property-tooltip.component.html',
  styleUrls: ['./property-tooltip.component.scss']
})
export class PropertyTooltipComponent extends TooltipComponent implements OnInit {
  @ViewChild(PropertyDetailPopupAnchorDirective) propertyDetailPopupAnchor: PropertyDetailPopupAnchorDirective;

  data: any;
  underwriteNowUrl: string;
  topBorderColor: string = ColorConstants.CHARCOAL_LIGHT;
  property: Observable<PropertyDetailJSON>;

  constructor(
    public element: ElementRef,
    private ngZone: NgZone
  ) {
    super(element);
  }

  ngOnInit() {
    this.data = this.feature.data;
    if(this.data.type === AppConstants.TYPES.STUDENT_HOUSING && this.data.propertyName.indexOf('*') < 0) {
      this.data.propertyName = `${this.data.propertyName} *`;
    }
    this.property = Observable.of(this.data);
    this.underwriteNowUrl = environment.underwriterUrl + '/#/' + this.data.propertyId + '/product-detail';
  }

  showPropertyProfilePopup() {
    this.ngZone.run(() => {
      this.propertyDetailPopupAnchor.createPropertyDetailPopup(PropertyDetailPopupComponent, this.data);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/features/property/components/map/property-tooltip.component.ts